const BaseUrl = process.env.MONO_BASE;
const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  /**
   * Fetch list of snippets by owner ID.
   * @param {Number} owner - The owner ID to fetch snippets for.
   * @returns {Promise} - A promise that resolves to the response of the fetch request.
   */
  async getSnippets(owner) {
    const resp = await fetch(getUrl('/snippets'), {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      headers: {
        'Tgb-Owner': owner,
      },
    });

    return resp.json();
  },
};
